<template>
  <v-container 
    grid-list-md fluid
  >
    <!-- fluid  -->
    <!-- fill-height -->
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="pa-2">
          <v-layout row wrap>
          <v-flex md8 sm12><!-- prestaciones -->
            <v-combobox
              v-model="prestacionesSelected"
              :items="informarPrestaciones"
              item-text="nombre_prestacion"
              item-value="id_prestacion"
              label="Prestaciones"
              prepend-icon="check_box"
              background-color="tertiary"
              color="primary"
              return-object
              multiple
              chips
              box
            ></v-combobox>
            <!-- readonly -->
          </v-flex>
          <v-flex md4 sm12><!-- estado -->
            <v-text-field
              v-model="estado"
              prepend-icon="layers"
              label="Estado"
              type="text"
              color="primary"
              readonly
              box
            ></v-text-field>
          </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-layout row wrap>
      <v-flex md4 sm12><!-- Datos Paciente -->
        <v-card id="personal_data" class="pa-2">
          <!-- <v-flex xs12><! IDPaciente >
            <v-text-field
              v-model="IDPaciente"
              prepend-icon="credit_card"
              label="ID Paciente"
              type="text"
              color="primary"
              readonly
              box
            ></v-text-field>
          </v-flex> -->
          <v-flex xs12><!-- nombre_paciente -->
            <v-text-field
              v-model="nombre_paciente"
              prepend-icon="person"
              label="Nombre Paciente"
              type="text"
              color="primary"
              readonly
              box
            ></v-text-field>
          </v-flex>
          <!-- <v-flex xs12><! sexo_paciente >
            <v-text-field
              v-model="sexo_paciente"
              label="Sexo paciente"
              prepend-icon="sentiment_satisfied_alt"
              color="primary"
              readonly
              box
            ></v-text-field>
          </v-flex> -->
          <!-- <v-flex xs12><! fecha_nacimiento >
            <v-text-field
              v-model="fecha_nacimiento"
              label="Fecha naciemiento paciente"
              hint="DD/MM/YYYY"
              persistent-hint
              prepend-icon="event"
              color="primary"
              readonly
              box
            ></v-text-field>
          </v-flex> -->
          <v-flex xs12><!-- edad_paciente -->
            <v-text-field
              v-model="edad_paciente"
              prepend-icon="cake"
              label="Edad Paciente"
              type="number"
              color="primary"
              readonly
              box
            ></v-text-field>
          </v-flex>
          <!-- <v-flex xs12><! correo_paciente >
            <v-text-field
              v-model="correo_paciente"
              prepend-icon="mail"
              label="Correo Paciente"
              type="text"
              color="primary"
              readonly
              box
            ></v-text-field>
          </v-flex> -->
          <v-flex xs12><!-- antecedentes_clinicos -->
            <v-textarea              
              v-model="antecedentes_clinicos"
              prepend-icon="assignment_ind"
              label="Antecedentes clínicos"
              color="primary"
              box
              readonly
            ></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn 
              small 
              block 
              :loading="loading"
              :disabled="loading"
              color="accent"
              class="black--text"
              @click="viewImage" 
            >Ver Orden Médica</v-btn>
              <!-- class="mr-0 pr-0" -->
          </v-flex>
        </v-card>
      </v-flex>
      <v-flex md8 sm12><!-- Datos Examen -->
        <v-card id="exam_data" class="pa-2">
          <!-- <v-flex xs12><! modalidad >
            <v-text-field
              v-model="modalidad"
              prepend-icon="dns"
              label="Modalidad"
              type="text"
              color="primary"
              readonly
              box
            ></v-text-field>
          </v-flex> -->
          <v-flex xs12><!-- comentario_tm -->
            <v-textarea
              v-model="comentario_tm"
              label="Comentario TM"
              prepend-icon="assignment"
              color="primary"
              readonly
              box
            ></v-textarea>
          </v-flex>
          <!-- <v-flex xs12><! medico_solicitante >
            <v-text-field
              v-model="medico_solicitante"
              prepend-icon="local_hospital"
              label="Médico Solicitante"
              type="text"
              color="primary"
              readonly
              box
            ></v-text-field>
          </v-flex> -->
          <v-flex xsx12><!-- plantilla -->
            <v-combobox
              v-model="plantilla"
              :items="selectPlantillas"
              item-text="nombre_plantilla"
              item-value="id_plantilla"
              label="Seleccione una plantilla"
              prepend-icon="dns"
              background-color="tertiary"
              color="primary"
              return-object
              box
              @change="setPlantillaExamen"
            ></v-combobox>
          </v-flex>
                    
          <v-flex xs12><!-- hallazgos -->
            <v-editor v-model="hallazgos" title="Contenido Informe" extraclass="elevation-0" dark></v-editor>
          </v-flex>
          
          <v-flex xs12><!-- patologiaGrave -->
            <v-switch
              v-model="patologiaGrave"
              :label="`Notificar Patología Grave: ${patologiaGrave ? 'SI' : 'NO'}`"
              color="red"
              value="1"
              class="ml-4"
            ></v-switch>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>

    <template><!-- viewer -->
      <v-container d-none grid-list-sm fluid>
        <v-layout row wrap v-viewer="viewerOptions" class="viewer" ref="viewer">
          <figure v-for="(image, index) in images" :key="index">
              <img 
                class="responsive-img"
                :src="image.url" 
                :data-source="image.url" 
                alt="Orden Médica"
                width="200"
              />
          </figure>
        </v-layout>
      </v-container>
    </template>

    <v-layout row wrap>
      <v-flex xs12 row justify-end align-end><!-- acciones -->
        <v-btn depressed :to="{name:'Exams'}">Volver</v-btn>
        <v-btn color="primary" @click="saveData()" :loading="loading">Guardar</v-btn>
        <v-btn v-if="informe" color="info" @click="preViewReport()" :loading="loading">Previsualizar Informe</v-btn>
        <v-btn color="success" @click="saveData(1)" :loading="loading">Validar</v-btn>
      </v-flex>
    </v-layout>

    <v-snackbar v-model="snack" :timeout="snackTime || 3000" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Cerrar</v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
  import axios from "axios";
  import { bus } from "./../main";
  import { rejects } from 'assert';
  var moment = require("moment");
  var configBaseAxios = {
    timeout: 10000,
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'x-www-form-urlencoded',
    },
    params: {}
  }
  export default {
    mounted() {
      this.logged_user = JSON.parse(localStorage.getItem("logged_user"))

      this.init()
    },
    data: vm => ({
      pagename: 'Informar Examen',
      logged_user: null,
      snack: false,
      snackColor: '',
      snackTime: null,
      snackText: '',
      loading: false,
      examen: null,
      informe: null,
      modEditPerson: false,
      informarPrestaciones: [],
      prestacionesSelected: [],
      estado: '',
      IDPaciente: '',
      nombre_paciente: '',
      sexo_paciente: '',
      fecha_nacimiento: '',
      edad_paciente: '',
      correo_paciente: '',
      antecedentes_clinicos: '',
      modalidad: '',
      comentario_tm: '',
      medico_solicitante: '',
      selectPlantillas: [],
      plantilla: null,
      tecnica: '',
      hallazgos: '',
      impresion: '',
      patologiaGrave: 0,
      viewerOptions: {
        toolbar: true,
        url: 'data-source'
      },
      images: [],

    }),
    methods: {
      init () {
        if (this.logged_user && this.logged_user.id_perfil == 4) {
          this.$router.push({ name: 'Find' })
        }
        
        //console.log('name', this.pagename, this.$route.query.prestaciones)
        let observable = [this.getExamen()]

        
        if (this.$route.query.id_informe) {
          observable.push( this.getInforme() )
        }

        Promise
          .all(observable)
          .then(() => {
            // console.log('promesa lista')
            this.getPlantillas()
            this.initForm()
          })
          .catch(reason => {
            // console.log('Fail', reason)
            setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
          })
      },
      initForm () {
        if (this.$route.query.id_informe) {
          this.informarPrestaciones = this.examen.prestaciones.filter(el => this.informe.prestaciones_informe.includes(el.id_prestacion) || el.informado === 0)
          this.tecnica = this.informe.tecnica_informe
          this.hallazgos = this.informe.hallazgo_informe
          this.impresion = this.informe.impresion_informe
          this.patologiaGrave = this.informe.patologiaGrave_informe
        }else {
          this.informarPrestaciones = this.examen.prestaciones.filter(el => el.informado === 0)
        }
        this.prestacionesSelected = this.getPrestacionesSelected()
        // console.log('this.prestacionesSelected', JSON.parse(JSON.stringify(this.prestacionesSelected)))
        this.estado = this.examen.nombre_estado
        this.IDPaciente = this.examen.IDPaciente
        this.nombre_paciente = this.examen.nombre
        this.sexo_paciente = this.examen.sexo
        this.fecha_nacimiento = this.examen.fecha_nacimiento
        this.edad_paciente = this.examen.edad
        this.correo_paciente = this.examen.correo_paciente
        this.antecedentes_clinicos = this.examen.antecedentes_clinicos

        this.modalidad = this.examen.modalidad
        this.comentario_tm = this.examen.comentario_TM
        this.medico_solicitante = this.examen.medico_solicitante
        this.images = this.examen.archivos.filter(el => el.tipo == 'orden')
      },

      getInforme () {
        return new Promise((resolve, reject) => {
          configBaseAxios.params = {
            accion: 'informe',
            opcion: 'ver',
            id_informe: this.$route.query.id_informe,
            api_token: this.logged_user.api_token
          }
          axios
            .create(configBaseAxios)
            .get(window.base_path + window.ws)
            .then(result => {
              if (result.data.response) {
                // console.log('informe', JSON.parse(JSON.stringify(result.data.callback)))
                this.informe = result.data.callback
                resolve()
              } else {
                reject('No data result')
              }
            })
            .catch(error => {
              reject('Error ajax')
            })
        })
      },

      getPrestacionesSelected () {
        let selected = []
        if (typeof this.$route.query.prestaciones === 'object') {
          selected = this.$route.query.prestaciones
        }else if (typeof this.$route.query.prestaciones === 'string') {
          selected.push(this.$route.query.prestaciones)
        }else if (this.$route.query.id_informe) {
          selected = this.informe.prestaciones_informe
        }
        // console.log('selected', selected)
        return this.informarPrestaciones.filter(el => {
          return selected.some(idp => {
            return idp == el.id_prestacion
          })          
        })
      },
      
      getExamen () {
        return new Promise((resolve, reject) => {
          configBaseAxios.params = {
            accion: 'examen',
            id_examen: this.$route.params.id_examen,
            api_token: this.logged_user.api_token
          }
          axios
            .create(configBaseAxios)
            .get(window.base_path + window.ws)
            .then(result => {
              if (result.data.response) {
                  // console.log('examen', JSON.parse(JSON.stringify(result.data.callback)))
                  this.examen = result.data.callback
                  resolve()
              } else {
                reject('No data result')
              }
            })
            .catch(error => {
              reject('Error ajax')
            })
        })
      },

      getPlantillas () {
        return new Promise((resolve, reject) => {
          configBaseAxios.params = {
            accion: 'plantillas',
            opcion: 'listarPlantillasModalidad',
            id_modalidad: this.examen.id_modalidad,
            api_token: this.logged_user.api_token
          }
          axios
            .create(configBaseAxios)
            .get(window.base_path + window.ws)
            .then(result => {
              if (result.data.response) {
                  // console.log('plantillas', JSON.parse(JSON.stringify(result.data.callback)))
                  this.selectPlantillas = result.data.callback
                  resolve()
              } else {
                reject('No data result')
              }
            })
            .catch(error => {
              reject('Error ajax')
            })
        })
      },

      setPlantillaExamen () { // console.log('setPlantillaExamen', this.plantilla)
        this.tecnica = this.plantilla.tecnica
        this.hallazgos = this.plantilla.hallazgos
        this.impresion = this.plantilla.impresiones
      },

      viewImage () {
        this.loading = true
        setTimeout(()=>{
          this.$refs['viewer'].$viewer.show()
          this.loading = false
        }, 1000)
      },

      preViewReport () {
        this.loadingExams = true


        configBaseAxios.params = {
          accion: 'informePDF',
          id_informe: this.informe.id_informe,
          api_token: this.logged_user.api_token
        }
        
        axios
          .create(configBaseAxios)
          .get(window.base_path + window.ws)
          .then(result => {
            // console.log('result', JSON.parse(JSON.stringify(result)))
            if(result.data.response) {

              window.open(result.data.ruta, '_blank')

            }else {
              // console.log('no link')
              this.snackColor = 'error'
              this.snackText = 'El informe del exámen no fué encontrado.'
              this.snack = true
            }
          })
          .catch(error => {
              // console.log('error', JSON.parse(JSON.stringify(result)))
              this.snackColor = 'error'
              this.snackText = error.response
              this.snack = true
              // setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
          })
          .then(() => {
            this.loadingExams = false
            this.snack = false
          })
      },

      saveData (validar ='0') {
        bus.$emit('getEditorContent')
        var contentData = {
          accion: 'informe',
          opcion: this.informe ? 'modificarInforme' : 'guardarInforme',
          id_informe: this.informe ? this.informe.id_informe : null,
          id_examen: this.examen.id,
          prestaciones: this.prestacionesSelected.map(el => el.id_prestacion).join(","),
          tecnica: this.tecnica,
          hallazgos: this.hallazgos,
          impresion: this.impresion,
          patologiaGrave: this.patologiaGrave || 0,
          validado: validar,
          api_token: this.logged_user.api_token
        }

        // console.log('saveData', JSON.parse(JSON.stringify(contentData)))

        axios({
            'method': 'post',
            'withCredentials': true,
            'url': window.base_path + window.ws, 
            'data': contentData
        })
        .then(result => { 
          // console.log('result editarPaciente', contentData, JSON.parse(JSON.stringify(result)))
          if(result.data.response) {
            this.snackColor = 'success'
            this.snackText = result.data.mensaje//message
            this.snack = true
            // if (validar==1) {
            //   this.$router.push({name: 'Exams'})
            // }else if ( ! confirm("¿Desea continuar editando este informe?") ) {
            //   this.$router.push({name: 'Exams'})
            // }else 
            if (validar==1) {
              this.$router.push({name: 'Exams'})
            }else if ( ! this.informe ) {
              //continuar editando
              this.$router.push({
                name: 'ExamReport', 
                params: {'id_examen': this.examen.id},
                query: {'id_informe': result.data.id_informe}
              })

              this.init()
              // console.log('continuar editando')
            }
          }else {
            this.snackColor = 'error'
            this.snackText = result.data.mensaje
            this.snack = true
          }
        })
        .catch(error => {
            // console.log('error',error)
            // reject(error.response)
            this.snackColor = 'error'
            this.snackText = error.mensaje
            this.snack = true
            // setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
        })
      }
    }
  }
</script>